import { render, staticRenderFns } from "./Promotion_information.vue?vue&type=template&id=2de39a93&scoped=true&"
import script from "./Promotion_information.vue?vue&type=script&lang=js&"
export * from "./Promotion_information.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_information.vue?vue&type=style&index=0&id=2de39a93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de39a93",
  null
  
)

export default component.exports